/* eslint-disable react/no-unused-prop-types */
import React from 'react';

import { Container } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  Tooltip as TooltipRecharts,
  XAxis,
  YAxis,
  Text,
  ResponsiveContainer,
} from 'recharts';

import { ObjectLiteral } from '~/types/generics';

import { ChartSkeleton } from './styles';

interface Props {
  data: any[];
}

interface XaxisValues {
  x: number;
  y: number;
  payload: ObjectLiteral;
}

const CustomizedAxisTick: React.FC<XaxisValues> = ({
  x,
  y,
  payload,
}: XaxisValues) => {
  return (
    <Text x={x} y={y} width={10} textAnchor="middle" verticalAnchor="start">
      {payload.value}
    </Text>
  );
};

const BarCharts: React.FC<Props> = ({ data }) => {
  const labelFormatter = (
    value: string | undefined,
    name: string | undefined,
    // eslint-disable-next-line consistent-return
  ) => {
    switch (name) {
      case 'inProgress':
        return [value, 'Em andamento'];
      case 'completed':
        return [value, 'Concluído'];
      case 'cancelled':
        return [value, 'Cancelado'];
      default:
    }
  };

  return (
    <Container>
      {data && data.length > 0 ? (
        <ResponsiveContainer width="95%" height={400}>
          <BarChart barGap={2} data={data}>
            <CartesianGrid vertical={false} />
            <XAxis
              interval={0}
              tick={({ x, y, payload }: XaxisValues) => (
                <CustomizedAxisTick x={x} y={y} payload={payload} />
              )}
              height={100}
              dataKey="name"
            />
            <YAxis />
            <TooltipRecharts
              formatter={(value: any, name: any) => labelFormatter(value, name)}
              offset={10}
            />
            <Legend />
            <Bar
              legendType="none"
              barSize={30}
              dataKey="inProgress"
              fill="#671966"
              radius={[4, 4, 0, 0]}
              minPointSize={2}
            />

            <Bar
              legendType="none"
              barSize={30}
              dataKey="completed"
              fill="#EB0045"
              radius={[4, 4, 0, 0]}
              minPointSize={2}
            />
            <Bar
              legendType="none"
              barSize={30}
              dataKey="cancelled"
              fill="#FF99B8"
              radius={[4, 4, 0, 0]}
              minPointSize={2}
            />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <>
          <ChartSkeleton>
            <Skeleton
              className="skeletonBar"
              animation="wave"
              variant="rect"
              height={90}
              width="3%"
            />
            <Skeleton
              className="skeletonBar"
              animation="wave"
              variant="rect"
              height={300}
              width="3%"
            />
            <Skeleton
              className="skeletonBar"
              animation="wave"
              variant="rect"
              height={100}
              width="3%"
            />
            <Skeleton
              className="skeletonBar"
              animation="wave"
              variant="rect"
              height={200}
              width="3%"
            />
            <Skeleton
              className="skeletonBar"
              animation="wave"
              variant="rect"
              height={270}
              width="3%"
            />
            <Skeleton
              className="skeletonBar"
              animation="wave"
              variant="rect"
              height={380}
              width="3%"
            />
            <Skeleton
              className="skeletonBar"
              animation="wave"
              variant="rect"
              height={180}
              width="3%"
            />
            <Skeleton
              className="skeletonBar"
              animation="wave"
              variant="rect"
              height={120}
              width="3%"
            />
            <Skeleton
              className="skeletonBar"
              animation="wave"
              variant="rect"
              height={360}
              width="3%"
            />
            <Skeleton
              className="skeletonBar"
              animation="wave"
              variant="rect"
              height={280}
              width="3%"
            />
            <Skeleton
              className="skeletonBar"
              animation="wave"
              variant="rect"
              height={90}
              width="3%"
            />
          </ChartSkeleton>
          <Skeleton
            style={{ marginLeft: 100, marginTop: 10 }}
            animation="wave"
            variant="rect"
            height={3}
            width="80%"
          />
        </>
      )}
    </Container>
  );
};

export default BarCharts;
